"use strict";

var _classCallCheck = require("/root/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/workspace/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/workspace/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/workspace/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/workspace/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_commands_1 = require("prosemirror-commands");

var markInputRule_1 = __importDefault(require("../lib/markInputRule"));

var Mark_1 = __importDefault(require("./Mark"));

var Strikethrough = /*#__PURE__*/function (_Mark_1$default) {
  _inherits(Strikethrough, _Mark_1$default);

  var _super = _createSuper(Strikethrough);

  function Strikethrough() {
    _classCallCheck(this, Strikethrough);

    return _super.apply(this, arguments);
  }

  _createClass(Strikethrough, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      return {
        "Mod-d": prosemirror_commands_1.toggleMark(type)
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref2) {
      var type = _ref2.type;
      return [markInputRule_1.default(/~([^~]+)~$/, type)];
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        mark: "strikethrough"
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "strikethrough";
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        parseDOM: [{
          tag: "s"
        }, {
          tag: "del"
        }, {
          tag: "strike"
        }],
        toDOM: function toDOM() {
          return ["del", 0];
        }
      };
    }
  }, {
    key: "toMarkdown",
    get: function get() {
      return {
        open: "~~",
        close: "~~",
        mixable: true,
        expelEnclosingWhitespace: true
      };
    }
  }, {
    key: "markdownToken",
    get: function get() {
      return "s";
    }
  }]);

  return Strikethrough;
}(Mark_1.default);

exports.default = Strikethrough;